import { render, staticRenderFns } from "./HeaderInformationNavigationJnjts.vue?vue&type=template&id=12a49352&scoped=true"
import script from "./HeaderInformationNavigationJnjts.vue?vue&type=script&lang=ts"
export * from "./HeaderInformationNavigationJnjts.vue?vue&type=script&lang=ts"
import style0 from "./HeaderInformationNavigationJnjts.vue?vue&type=style&index=0&id=12a49352&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a49352",
  null
  
)

export default component.exports